import React from 'react';
import Lottie from "react-lottie";
import animationData from './Success .json';
import classes from "../../style/Style.module.css"

const SuccessLottieAnimation = () => {
  const defaultOptions = {
    loop: false,
    autoplay: true,
    animationData: animationData,
  };

  return <Lottie options={defaultOptions} style={{height:"50vh",width:"80%"}} clasName={classes.SvgLogo}/>;
};

export default SuccessLottieAnimation;
